import React from 'react';
import { Card, Row, Col } from 'antd';
import styled from 'styled-components/macro';

import Heading from 'components/Heading/Heading';
import Description from 'components/Description/Description';
import Button from 'components/Button/Button';
import Tooltip from 'components/Tooltip/Tooltip';
import { SEARCH_MODE_BY_STATE, SEARCH_MODE_BY_ADDRESS } from 'utils/constants';

import AirbnbFilter from '../AirbnbFilter/AirbnbFilter';
import PlaceSearch from '../PlaceSearch/PlaceSearch';
import Legend from '../Legend/Legend';

import HostSearchIcon from './images/host-search-icon.png';

const StyledButtonContainer = styled.div`
  margin-top: 24px;
`;
const StyledRow = styled.div`
  width: 100% !important;
`;

const StyledSearchCard = styled(Card)`
  position: relative;
  @media (min-width: 992px) {
    height: 100%;
  }
`;

const renderMessage = (mode, numberOfHost, numberOfProperties) => {
  let hostString = '';
  if (numberOfHost > 1) {
    hostString = (
      <>
        <strong>{numberOfHost}</strong> hosts in{' '}
      </>
    );
  } else if (numberOfHost === 1) {
    hostString = (
      <>
        <strong>{numberOfHost}</strong> host in{' '}
      </>
    );
  }
  let propertiesString = '';
  if (numberOfProperties > 1) {
    propertiesString = (
      <>
        <strong>{numberOfProperties}</strong> properties
      </>
    );
  } else if (numberOfProperties === 1) {
    propertiesString = (
      <>
        <strong>{numberOfProperties}</strong> property
      </>
    );
  }
  if (!mode && numberOfProperties > 0) {
    return (
      <span>
        Showing all {hostString}
        {propertiesString}
      </span>
    );
  } else {
    if (numberOfProperties <= 0) {
      return <span>Oops, we couldn't find any properties near this area. Is your property in this area? Enquire now!</span>;
    } else {
      if (mode === SEARCH_MODE_BY_STATE) {
        return (
          <span>
            Great! We found {hostString}
            {propertiesString} in this area
          </span>
        );
      } else if (mode === SEARCH_MODE_BY_ADDRESS) {
        return (
          <span>
            Great! We found {hostString}
            {propertiesString} within 10km of this area
          </span>
        );
      }
    }
  }
};

const SearchCard = ({ defaultAddress, numberOfHost, numberOfProperties, mode, setDisplayAddress, onAirbnbFilter, onEnquireClick, onSearch }) => {
  return (
    <StyledSearchCard>
      <Row gutter={16} type="flex" justify="space-between" align="top">
        <Col span={6} md={3} style={{ paddingTop: '8px' }}>
          <img src={HostSearchIcon} alt="Search Host icon" height={48} />
        </Col>
        <Col span={18} md={21} style={{ wordBreak: 'break-word' }}>
          <Heading color="primary" size="regular">
            Search Hosts
          </Heading>
        </Col>
      </Row>
      <div style={{ marginBottom: '24px' }}>
        <Tooltip message={renderMessage(mode, numberOfHost, numberOfProperties)} />
      </div>
      <PlaceSearch size="large" label="Location" defaultAddress={defaultAddress} setDisplayAddress={setDisplayAddress} onSearch={onSearch} />
      <AirbnbFilter onSelectionChange={onAirbnbFilter} />
      <Description size="large">Legend</Description>
      <Legend />
      <StyledButtonContainer>
        <StyledRow>
          <Row gutter={12}>
            <Col span={12}>
              <Button size="large" style={{ width: '100%' }} type="secondary" toUrl="/">
                Home
              </Button>
            </Col>
            <Col span={12}>
              <Button size="large" style={{ width: '100%' }} type="primary" onClick={onEnquireClick}>
                Enquire Now
              </Button>
            </Col>
          </Row>
        </StyledRow>
      </StyledButtonContainer>
    </StyledSearchCard>
  );
};

SearchCard.defaultProps = {
  defaultAddress: '',
  numberOfHost: 0,
  numberOfProperties: 0,
  mode: '',
  onEnquireClick: () => {}
};

export default SearchCard;
